import { useEffect, useRef } from "react";

import { useAppDispatch, useAppSelector } from "~/hooks/reduxHooks";
import { useSnacks } from "~/providers/SnackProvider";
import { setErrorsViewed } from "~/store/errorSlice";

const MAX_ERROR_SNACKS_PER_BATCH = 2;

const ErrorSnackBridge = (): null => {
	const firedIds = useRef<Set<string>>(new Set());

	const [openSnack] = useSnacks();
	const dispatch = useAppDispatch();
	const errors = useAppSelector((state) => state.error?.errors ?? []);
	const newErrors = useAppSelector((state) => state.error?.newErrors ?? 0);

	useEffect(() => {
		if (newErrors === 0) return;
		const unviewed = errors.filter((e) => !e.viewed);
		if (unviewed.length === 0) return;

		const snackErrors = unviewed
			.filter(
				(e): e is typeof e & { id: string; userMessage: string } =>
					typeof e.id === "string" &&
					typeof e.userMessage === "string" &&
					e.userMessage.length > 0 &&
					!firedIds.current.has(e.id)
			)
			.slice(0, MAX_ERROR_SNACKS_PER_BATCH);

		snackErrors.forEach(({ id, userMessage }) => {
			firedIds.current.add(id);
			openSnack(userMessage, "error", false, undefined, undefined, { skipLog: true });
		});

		dispatch(setErrorsViewed());
	}, [errors, newErrors, openSnack]);

	return null;
};

export default ErrorSnackBridge;
